
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software",
      function () {
        return require("private-next-pages/software.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software"])
      });
    }
  